"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interface = void 0;
var Interface;
(function (Interface) {
    Interface["WEBSITE"] = "Website";
    Interface["MOBILE"] = "Mobile responsive";
    Interface["TABLET"] = "Tablet responsive";
    Interface["ANDROID_PHONE"] = "Smartphone Android app";
    Interface["ANDROID_TABLET"] = "Tablette Android app";
    Interface["IOS_PHONE"] = "Iphone app";
    Interface["IOS_TABLET"] = "Ipad app";
    Interface["WEBVIEW_PHONE"] = "Mobile app";
    Interface["WEBVIEW_TABLET"] = "Tablet app";
})(Interface || (exports.Interface = Interface = {}));
